import React, { useEffect, useRef } from 'react';

const ProductDescriptionIframe: React.FC<{ src: string; }> = ({ src }) => {
    const [protocol, , host] = src.split('/');
    const iframe = useRef<HTMLIFrameElement>(null);
    const iframeOrigin = `${protocol}//${host}`;

    useEffect(() => {
        window.addEventListener('message', event => {
            if (event.origin !== iframeOrigin) {
                return;
            }

            if (!event.data) {
                return;
            }

            if (iframe.current) {
                iframe.current.height = `${parseInt(event.data) + 32}px`;
            }
        }, { passive: true });
    }, [iframeOrigin]);

    return (
        <div className="product-description-iframe">
            <iframe
                ref={iframe}
                src={src}
                title="multimediaContent"
                frameBorder="0"
                scrolling="no"
                width="100%"
            />
        </div>
    );
};

export default ProductDescriptionIframe;
